// extracted by mini-css-extract-plugin
export var ticketsCards = "Tickets-module--ticketsCards--pA6fN";
export var ticketsCta = "Tickets-module--ticketsCta--G+EWq";
export var ticketsPrimoCard = "Tickets-module--ticketsPrimoCard--8dle1";
export var ticketsSpectateCard = "Tickets-module--ticketsSpectateCard--VotHT";